import { render, staticRenderFns } from "./campaign-tabs.vue?vue&type=template&id=2bb9ce52&scoped=true&"
import script from "./campaign-tabs.vue?vue&type=script&lang=js&"
export * from "./campaign-tabs.vue?vue&type=script&lang=js&"
import style0 from "./campaign-tabs.vue?vue&type=style&index=0&id=2bb9ce52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9ce52",
  null
  
)

export default component.exports